import { render } from "./AposCommandMenuKeyList.vue?vue&type=template&id=2fd6681e&scoped=true"
import script from "./AposCommandMenuKeyList.vue?vue&type=script&lang=js"
export * from "./AposCommandMenuKeyList.vue?vue&type=script&lang=js"

import "./AposCommandMenuKeyList.vue?vue&type=style&index=0&id=2fd6681e&lang=scss&scoped=true"

import exportComponent from "../../../../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fd6681e"],['__file',"command-menu/ui/apos/components/AposCommandMenuKeyList.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2fd6681e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2fd6681e', __exports__)) {
    api.reload('2fd6681e', __exports__)
  }
  
  module.hot.accept("./AposCommandMenuKeyList.vue?vue&type=template&id=2fd6681e&scoped=true", () => {
    api.rerender('2fd6681e', render)
  })

}


export default __exports__